// @ts-ignore
import numeral from 'numeral'

export const formatNumbers = (val: any) => {
  return numeral(val).format('0.0a')
}
export const formatNumberAsWholeNumber = (val: any) => {
  return numeral(val).format('0a')
}
